import React, { useState, useEffect, } from "react";
import config from "config";
import Spinner from "NOTICEBOARD/CommonResources/SpinnerLoader/Spinner";
import NoticeboardAPICall from "NoticeboardAPICall"; import {
	Close, Add, DataObjectSharp
} from "@mui/icons-material";
import 'NOTICEBOARD/Components/Notices/Assignees/Assignees.css'
import SuccessModal from 'NOTICEBOARD/CommonResources/SuccessModal/SuccessModal';
import Pagination from 'react-js-pagination';
import ConfirmationModal from "NOTICEBOARD/Components/ConfirmationModal/ConfirmationModal";
import { height } from "@mui/system";
import { ToastContainer, toast } from "react-toastify";



function Assignees({ noticeIdStateForAssignee, instituteDepartment,noticeList, setNoticeList, noticeTitleStateForAssignee, setShowSideBarAssignees }) {
	// api path

	let apiPathGetNoticeList = '/api/notice/notice.php';
	let apiPathRemoveNoticeAssignee = '/api/notice/notice.php';
	let apiPathAcademicYearListObject = "/api/admission/streamManagement.php";
	let apiPathGetInstituteStreamsObject = '/api/admission/streamManagement.php';
	let apiPathGetGroupList = '/api/admission/groupDetails.php';
	let apiPathGetFacultyList = '/api/instructor/facultyRegistration.php';
	let apiPathGetStudentAssignedToGroup = '/api/admission/groupDetails.php';
	let apiPathAddNoticeAssignee = '/api/notice/notice.php';

	// states for getting data    
	const [noticeAssigneeList, setNoticeAssigneeList] = useState({});
	const [instDept, setInstDept] = useState("");
	const [getAcademicYearListObject, setGetAcademicYearListObject] = useState({});
	const [academicYearSortedArr, setAcademicYearSortedArr] = useState([]);
	const [instituteStreamsObject, setInstituteStreamsObject] = useState({});
	const [getGroupList, setGetGroupList] = useState({});
	const [getFacultyList, setGetFacultyList] = useState({});
	const [getStudentAssignedToGroup, setGetStudentAssignedToGroup] = useState({});
	const [studentSequence, setStudentSequence] = useState([]);
	const [addNoticeAssignee, setAddNoticeAssignee] = useState({})

	// states for spinners
	const [dataFetchingNoticeAssigneeList, setDataFetchingNoticeAssigneeList] = useState(false);
	const [dataFetchingRemoveAssignee, setDataFetchingRemoveAssignee] = useState(false);
	const [dataFetchingGetAcademicYearListObject, setDataFetchingGetAcademicYearListObject] = useState(false);
	const [dataFetchingGetInstituteStreamsObject, setDataFetchingGetInstituteStreamsObject] = useState(false);
	const [dataFetchingGetGroupList, setDataFetchingGetGroupList] = useState(false);
	const [dataFetchingGetFacultyList, setDataFetchingGetFacultyList] = useState(false);
	const [dataFetchinGetStudentAssignedToGroup, setDataFetchingGetStudentAssignedToGroup] = useState(false);
	const [dataFetchingAddNoticeAssignee, setDataFetchingAddNoticeAssignee] = useState(false);

	// STATES FOR GET ASSIGNEE
	const [getAssignee, setAssignee] = useState({
		userType: "",
		academicYearId: "",
		departmentId: "",
		groupId: ""
	})

	// STATES FOR SUCCESS MODAL 
	const [successModalDetails, setSuccessModalDetails] = useState({
		successModal: false,
		successModalType: '',
		successMessage: ''
	});

	// states for modal , sidebar and table
	const [showModalAddAssinees, setShowModalAddAssinees] = useState(false)
	const [showModalConfirmation, setShowModalConfirmation] = useState(false)
	const [showInstructions, setShowInstructions] = useState(true)
	// const [warningMessage, setWarningMessage] = useState('Please select filter.')
	const [isStudentTable, setIsStudentTable] = useState(true)
	const [isClickOnSearch, setIsClickOnSearch] = useState(false)
	const [isClickOnView, setIsClickOnView] = useState(false)

	// states for manipulating data
	const [tempNoticeAssigneeArrayForDelete, setTempNoticeAssigneeArrayForDelete] = useState([])
	const [tempNoticeAssigneeArray, setTempNoticeAssigneeArray] = useState([])
	const [tempAddAssignee, setTempAddAssignee] = useState({})

	// STATES AND METHODS FOR PAGINATION
	const [totalCount, setTotalCount] = useState(0);
	const [pagination, setPagination] = useState({
		pageIndex: 1,
		limit: 250,
		offset: 0
	});

	// METHOD FOR USER PAGINATION COUNT
	const updatePaginationCount = (pageNumber) => {
		setPagination({
			offset: ((pageNumber - 1) * pagination.limit),
			pageIndex: pageNumber,
			limit: pagination.limit
		})
	}

	// FUNCTION FOR SELECT ALL ASSIGNEES
	const selectAllAssignees = (e) => {
		let noticeAssigneeSet = new Set();
		if (getAssignee.userType === 'student') {
			if (e.target.checked) {
				Object.keys(getStudentAssignedToGroup).map(studentId => {
					noticeAssigneeSet.add(studentId);
				})
			}
			else {
				Object.keys(getStudentAssignedToGroup).map(studentId => {
					noticeAssigneeSet.delete(studentId);
				})
			}
		}
		else if (getAssignee.userType === 'teaching' || getAssignee.userType === 'nonteaching') {
			if (e.target.checked) {
				Object.values(getFacultyList).map(faculty => {
					noticeAssigneeSet.add(faculty.faculty_id);
				})
			}
			else {
				Object.values(getFacultyList).map(faculty => {
					noticeAssigneeSet.delete(faculty.faculty_id);
				})
			}
		}
		setTempNoticeAssigneeArray(Array.from(noticeAssigneeSet))
	}

	// function for add assignee to temp array for concatinating array to assignee table after post assignee so we will not to call api.
	const addAssigneeToTempArray = () => {
		if (getAssignee.userType === 'student') {
			let temp = {};
			tempNoticeAssigneeArray.map(id => {
				temp[id] = {
					uniqueId: getStudentAssignedToGroup[id].studentId,
					userFirstName: getStudentAssignedToGroup[id].student_first_name,
					userLastName: getStudentAssignedToGroup[id].student_last_name,
					streamName: "",
					groupName: "",
					userRole: "student",
				}
			});
			setNoticeAssigneeList({ ...noticeAssigneeList, ...temp });
		}
		if (getAssignee.userType === 'teaching' || getAssignee.userType === 'nonteaching') {
			let temp = {};
			tempNoticeAssigneeArray.map(id => {
				Object.keys(getFacultyList).map(faculty => {
					if (getFacultyList[faculty].faculty_id === id) {
						temp[id] = {
							uniqueId: getFacultyList[faculty].faculty_id,
							userFirstName: getFacultyList[faculty].faculty_fname,
							userLastName: getFacultyList[faculty].faculty_lname,
							streamName: "",
							groupName: "",
							userRole: getFacultyList[faculty].userrole,
						}
					}
				})

			});
			setNoticeAssigneeList({ ...noticeAssigneeList, ...temp });
		}

	}

	// FUNCTION FOR SELECT ONE ASSIGNEES
	const selectOneAssignees = (id) => {

		if (getAssignee.userType === 'student') {
			if (tempNoticeAssigneeArray.includes(id)) {
				setTempNoticeAssigneeArray(tempNoticeAssigneeArray.filter(ids => ids !== id));
			}
			else {
				setTempNoticeAssigneeArray([...tempNoticeAssigneeArray, id]);
			}
		}
		if (getAssignee.userType === 'teaching' || getAssignee.userType === 'nonteaching') {
			if (tempNoticeAssigneeArray.includes(id)) {
				setTempNoticeAssigneeArray(tempNoticeAssigneeArray.filter(ids => ids !== id));
			}
			else {
				setTempNoticeAssigneeArray([...tempNoticeAssigneeArray, id]);
			}

		}
	}

	// FUNCTION FOR SELECT ALL ASSIGNEES FOR DELETE

	const selectAllAssigneesForDelete = () => {
		if (tempNoticeAssigneeArrayForDelete.length === Object.keys(noticeAssigneeList).length) {
			setTempNoticeAssigneeArrayForDelete([])
		} else {
			let result = Object.keys(noticeAssigneeList).map(key => noticeAssigneeList[key].uniqueId);
			setTempNoticeAssigneeArrayForDelete(result)
		}
	}

	// FUNCTION FOR SELECT ONE ASSIGNEES FOR DELETE
	const selectOneAssigneesForDelete = (id) => {
		if (tempNoticeAssigneeArrayForDelete.includes(id)) {
			setTempNoticeAssigneeArrayForDelete(tempNoticeAssigneeArrayForDelete.filter(ids => ids !== id));
		}
		else {
			setTempNoticeAssigneeArrayForDelete([...tempNoticeAssigneeArrayForDelete, id]);
		}
	}

	useEffect(() => {
		getAcademicYearListObjectAPICall()
		getGetInstituteStreamsObject()
	}, [])

	// HOOKS FOR GET ASSIGNEE GROUP API CALL
	useEffect(() => {
		getGetGroupList()
	}, [getAssignee.academicYearId, getAssignee.departmentId])

	// HOOKS FOR GET  NOTICE ASSIGNEE LIST  API CALL
	useEffect(() => {
		getNoticeAssigneeList()
	}, [pagination])


	// METHOD FOR GET NOTICE ASSIGNEE LIST API CALL
	const getNoticeAssigneeList = async () => {
		setDataFetchingNoticeAssigneeList(true);
		let formData = {
			institute_id: config.institute_id,
			notice_id: noticeIdStateForAssignee,
			page_index: pagination.pageIndex,
			limit: pagination.limit,
			filter_role: getAssignee.userType,
			filter_department: getAssignee.departmentId,
			filter_group: getAssignee.groupId
		};

		let jsonResponse = await NoticeboardAPICall.makeApiCall(
			"getNoticeAssigneeList",
			formData,
			apiPathGetNoticeList
		);
		if (jsonResponse.expired) {
			setTimeout(() => {
				getNoticeAssigneeList();
			}, 1000);
		} else {
			if (jsonResponse.success) {
				let apiResult = jsonResponse.APIResult.data;
				setNoticeAssigneeList(apiResult);
				setTotalCount(jsonResponse.APIResult.totalCount)
				setDataFetchingNoticeAssigneeList(false);
			} else {
				setDataFetchingNoticeAssigneeList(false);
			}
		}

	}

	// METHOD FOR REMOVE NOTICE ASSIGNEE API CALL

	const postRemoveNoticeAssignee = async () => {
		setDataFetchingRemoveAssignee(true);
		let formData = {
			institute_id: config.institute_id,
			notice_id: noticeIdStateForAssignee,
			assignee_id_array: tempNoticeAssigneeArrayForDelete,
		};
		let jsonResponse = await NoticeboardAPICall.makeApiCall(
			"removeNoticeAssignee",
			formData,
			apiPathRemoveNoticeAssignee
		);
		if (jsonResponse.expired) {
			setTimeout(() => {
				postRemoveNoticeAssignee();
			}, 1000);
		} else {
			setDataFetchingRemoveAssignee(false);
			setShowModalConfirmation(false);
			if (jsonResponse.success) {
				let apiResult = jsonResponse.APIResult;
				let noticeAssigneeListdetails = noticeAssigneeList;
				if (apiResult.status == 'success') {
					tempNoticeAssigneeArrayForDelete.map(assigneeId => {
						delete noticeAssigneeListdetails[assigneeId];
					});

					setSuccessModalDetails({
						successModal: true,
						successModalType: "success",
						successMessage: apiResult.message,
					});
					// setNoticeAssigneeList({ ...noticeAssigneeListdetails })
					setTempNoticeAssigneeArrayForDelete([]);
					setTotalCount(totalCount - tempNoticeAssigneeArrayForDelete.length);
				} else {
					setSuccessModalDetails({
						successModal: true,
						successModalType: "warning",
						successMessage: apiResult.message
					});
				}
			} else {
				setSuccessModalDetails({
					successModal: true,
					successModalType: "error",
					successMessage: 'Something went wrong while removing assignee. Please try again later.'
				});
			}
		}

	}


	//METHOD TO GET ACADEMIC LIST CLEAR
	const clearNoticeAssigneeList = () => {
		setAssignee({
			userType: "",
			academicYearId: "",
			departmentId: "",
			groupId: ""
		})
		setPagination({
			pageIndex: 1,
			limit: 250,
			offset: 0
		});
	}

	// METHOD TO GET Academic Year API CALL    
	const getAcademicYearListObjectAPICall = async () => {
		setDataFetchingGetAcademicYearListObject(true);

		let formData = {
			"iid": config.institute_id,
		}
		let jsonResponse = await NoticeboardAPICall.makeApiCall(
			'GetAcademicYearListObject',
			formData,
			apiPathAcademicYearListObject
		);
		if (jsonResponse.expired) {
			setTimeout(() => {
				getAcademicYearListObjectAPICall();
			}, 1000);
		} else {
			if (jsonResponse.success) {
				let apiResult = jsonResponse.APIResult.data;
				setGetAcademicYearListObject(apiResult);
				setAcademicYearSortedArr(jsonResponse.APIResult.sortedIdArray);

				setDataFetchingGetAcademicYearListObject(false);
			} else {
				setDataFetchingGetAcademicYearListObject(false);
				// setSuccessModalDetails({
				//     successModal:true,
				//     successModalType:"error",
				//     successMessage:"Something went wrong while getting category list. Please try again later."
				// });
			}
		}

	}

	// METHOD FOR Get INSTITUTE STREAMS OBJECT API CALL
	const getGetInstituteStreamsObject = async () => {
		setDataFetchingGetInstituteStreamsObject(true);
		let formData = {
			"iid": config.institute_id,
			"sidArray": []
		}

		let jsonResponse = await NoticeboardAPICall.makeApiCall(
			'GetInstituteStreamsObject',
			formData,
			apiPathGetInstituteStreamsObject
		);


		if (jsonResponse.expired) {
			setTimeout(() => {
				getGetInstituteStreamsObject();
			}, 1000);
		} else {
			if (jsonResponse.success) {
				let apiResult = await jsonResponse.APIResult.data;
				setInstituteStreamsObject(apiResult)
				setDataFetchingGetInstituteStreamsObject(false);
			} else {
				setDataFetchingGetInstituteStreamsObject(false);
				// setSuccessModalDetails({
				//     successModal: true,
				//     successModalType: "error",
				//     successMessage: "Something went wrong while getting category list. Please try again later."
				// });
			}
		}
	}

	// METHOD FOR Get INSTITUTE STREAMS OBJECT API CALL
	const getGetGroupList = async () => {

		setDataFetchingGetGroupList(true);
		let formData = {
			"iid": config.institute_id,
			"sidArray": [getAssignee.departmentId],
			"academicIdArray": [getAssignee.academicYearId],
			"pageIndex": 1,
			"limitPerPage": 1000,
			"displayType": "",
			"deleteStatus": "",
			"BatchIdArray": [],
			"sidNameRequired": true,
			"academicYearNameRequired": true,
			"batchNameRequired": true
		}

		let jsonResponse = await NoticeboardAPICall.makeApiCall(
			'GetGroupList',
			formData,
			apiPathGetGroupList
		);

		if (jsonResponse.expired) {
			setTimeout(() => {
				getGetGroupList();
			}, 1000);
		} else {
			if (jsonResponse.success) {
				let apiResult = await jsonResponse.APIResult.data;
				setGetGroupList(apiResult)
				setDataFetchingGetGroupList(false);
			} else {
				setDataFetchingGetGroupList(false);
				// setSuccessModalDetails({
				//     successModal: true,
				//     successModalType: "error",
				//     successMessage: "Something went wrong while getting category list. Please try again later."
				// });
			}
		}
	}

	// METHOD FOR GET FACULTY LIST API CALL
	const getGetFacultyList = async () => {
		setDataFetchingGetFacultyList(true);
		let formData = {
			"iid": config.institute_id,
			"type": "all",
			"page_index": 1,
			"limit": 1000,
			"status": '0',
			"role": getAssignee.userType,
			"search": "",
			"selectedStream": getAssignee.departmentId != "" ? getAssignee.departmentId :0,
			"selectedDepartment": instDept != "" ? instDept : 0
		}

		let jsonResponse = await NoticeboardAPICall.makeApiCall(
			'getFacultyList',
			formData,
			apiPathGetFacultyList
		);
		if (jsonResponse.expired) {
			setTimeout(() => {
				getGetFacultyList();
			}, 1000);
		} else {
			if (jsonResponse.success) {
				let apiResult = jsonResponse.APIResult.data;
				setGetFacultyList(apiResult)
				setDataFetchingGetFacultyList(false);
			} else {
				setDataFetchingGetFacultyList(false);
				// setSuccessModalDetails({
				//     successModal: true,
				//     successModalType: "error",
				//     successMessage: "Something went wrong while getting category list. Please try again later."
				// });
			}
		}
	}

	// METHOD FOR Get Student Assigned To Group API CALL
	const getGetStudentAssignedToGroup = async () => {
		setDataFetchingGetStudentAssignedToGroup(true);
		let formData = {
			"iid": config.institute_id,
			"sid": getAssignee.departmentId,
			"groupId": getAssignee.groupId,
			"academicYear": getAssignee.academicYearId,
			"isStudentDetailsRequired": "true",
			"studentNameSearch": "",
			"isStudentDefaultGroupRequired": "true",
			"filterAccess" : 0
		}

		let jsonResponse = await NoticeboardAPICall.makeApiCall(
			'getStudentAssignedToGroup',
			formData,
			apiPathGetStudentAssignedToGroup
		);
		if (jsonResponse.expired) {
			setTimeout(() => {
				getGetStudentAssignedToGroup();
			}, 1000);
		} else {
			if (jsonResponse.success) {
				let apiResult = await jsonResponse.APIResult.data;
				if (Object.keys(apiResult).length > 0) {
					Object.keys(apiResult).map(studentId => {
						apiResult[studentId]['studentId'] = studentId;
					})
				}
				setGetStudentAssignedToGroup(apiResult);
				setStudentSequence(jsonResponse.APIResult.sortedIdArray);
				setDataFetchingGetStudentAssignedToGroup(false);
			} else {
				setDataFetchingGetStudentAssignedToGroup(false);
				// setSuccessModalDetails({
				//     successModal: true,
				//     successModalType: "error",
				//     successMessage: "Something went wrong while getting category list. Please try again later."
				// });
			}
		}
	}


	// METHOD FOR ADD NOTICE ASSIGNEE API CALL
	const postAddNoticeAssignee = async () => {
		let formData = {
			"institute_id": config.institute_id,
			"notice_id": noticeIdStateForAssignee,
			"user_role": getAssignee.userType,
			"sid": getAssignee.departmentId !="" ? getAssignee.departmentId :0,
			"group_id": getAssignee.groupId,
			"instituteDepartment": instDept !="" ? instDept : 0,
			"assignee_id_array": tempNoticeAssigneeArray,
			"added_by": config.faculty_id,
			"aca_yr": getAssignee.academicYearId
		}
		let jsonResponse = await NoticeboardAPICall.makeApiCall(
			'addNoticeAssignee',
			formData,
			apiPathAddNoticeAssignee
		);
		if (jsonResponse.expired) {
			setTimeout(() => {
				postAddNoticeAssignee();
			}, 1000);
		} else {
			if (jsonResponse.success) {
				let apiResult = await jsonResponse.APIResult.data;
				setAddNoticeAssignee(apiResult)
				setDataFetchingAddNoticeAssignee(false);
				setSuccessModalDetails({
					successModal: true,
					successModalType: "success",
					successMessage: jsonResponse.APIResult.message
				});
				clearGetAssignee()
				addAssigneeToTempArray()
				setTotalCount(totalCount + Object.keys(noticeAssigneeList).length);
				setPagination({
					offset: 0,
					pageIndex: 1,
					limit: 250
				})
				noticeList[noticeIdStateForAssignee].assigneeCount = parseInt(tempNoticeAssigneeArray.length) + parseInt(noticeList[noticeIdStateForAssignee].assigneeCount);
				setNoticeList({ ...noticeList });
			} else {
				setDataFetchingAddNoticeAssignee(false);
				setSuccessModalDetails({
					successModal: true,
					successModalType: "error",
					successMessage: "Something went wrong while adding notice. Please try again later."
				});
			}
		}
	}

	// METHOD FOR SEARCH ASSIGNEE VALIDATION WARNING
	const showImpWarning = (msgfor) => {
		if (isClickOnSearch) {
			return <p className='warningMessage'>{ `Please Select ${msgfor}` }</p>
		}
	}
	// METHOD FOR SEARCH POST ASSSIGNEE
	const searchAssignee = async () => {
		setIsClickOnSearch(true)
		setTempNoticeAssigneeArray([])

		if (getAssignee.userType === '') {
			// setWarningMessage('Please select filter.')
		}
		if (getAssignee.userType === 'student') {
			let isValidStudent = true;
			// setWarningMessage('If user type is Student then select Academic year, Deparmtent, Groups.')
			if (getAssignee.academicYearId === '') {
				isValidStudent = false;
			}
			if (getAssignee.departmentId === '') {
				isValidStudent = false;
			}
			if ((getAssignee.academicYearId === '' && getAssignee.departmentId === '')) {
				isValidStudent = false;
			}
			if (isValidStudent) {
				setShowInstructions(false)
				setIsStudentTable(true)
				getGetStudentAssignedToGroup()
				// setWarningMessage('Please select filter.')
			}
			else {

			}
		}
		if (getAssignee.userType === 'teaching' || getAssignee.userType === 'nonteaching') {
			let isValidFaculty = true;
			// setWarningMessage('If user type is Teaching or Non Teaching then select Department only.')
			if (getAssignee.departmentId === '' && instDept == "" ) 
			{
				isValidFaculty = false;
			}
			if (isValidFaculty) 
			{
				setShowInstructions(false)
				setIsStudentTable(false)
				getGetFacultyList()
				// setWarningMessage('Please select Department or Institute Department.')
			}
			else
			{
				toast.warning("Please select Department or Institute Department.")
			}
		}
	}
	const clearData = () => {
		// setNoticeAssigneeList({})
		// setGetAcademicYearListObject({})
		// setInstituteStreamsObject({})
		// setGetGroupList({})
		setGetFacultyList({})
		setGetStudentAssignedToGroup({})
		setTempNoticeAssigneeArray([])
		setShowInstructions(true)
		setIsStudentTable(true)
		clearGetAssignee();
		setInstDept("")
		setIsClickOnSearch(false);

	}

	const clearGetAssignee = () => {
		setAssignee({
			userType: "",
			academicYearId: "",
			departmentId: "",
			groupId: ""
		})
	}


	// METHOD TO CLOSE WARNING MODAL
	const closeSuccessModal = () => {
		setSuccessModalDetails({
			successModal: false,
			successModalType: "",
			successMessage: ""
		});
	}

	// all onchange methods 

	// onchange method for select user type
	const onChangeAssigneeUserType = (e) => {
		setAssignee(prev => ({ ...prev, userType: e.target.value }));
	}

	// onchange method for select year id
	const onChangeAssigneeYear = (e) => {
		setAssignee(prev => ({ ...prev, academicYearId: e.target.value }));
	}

	// onchange method for select department
	const onChangeAssigneeDepartment = (e) => {
		setAssignee(prev => ({ ...prev, departmentId: e.target.value }));
	}

	// onchange method for select group
	const onChangeAssigneeGroup = (e) => {
		setAssignee(prev => ({ ...prev, groupId: e.target.value }));
	}

	// METHOD FOR VIEW ASSIGNEE LIST

	const viewNoticeAssigneeList = () => {
		setPagination({
			pageIndex: 1,
			limit: 250,
			offset: 0
		}, () => {
			getNoticeAssigneeList();
		});
	}
	return <>
		{/* sidebar for assigness */ }
		<div id="sideBar">
			<div id="sideBarContainer" className="sideBarContainerAssignee">
				<div className="sideBarHeader d-flex justify-content-center align-items-center">
					<div style={ { cursor: "pointer" } }>
						<Close
							className="mx-2"
							onClick={ () => {
								setShowSideBarAssignees(false);
								clearData();
								setNoticeAssigneeList({})
							} }
						/>{ " " }
					</div>
					<div className="p-1 flex-grow-1 text-center">
						<p>Assignee</p>
					</div>
				</div>
				<div className="">
					<div className='col-12 my-2'>
						<div className='d-flex  align-items-center flex-wrap'>
							<div className='flex-grow-1 ' style={ { fontSize: '15px' } }>

								<div className='assigneeTitle'>{ noticeTitleStateForAssignee }</div>
							</div>
							<div className=''>
								<button
									type="button"
									className="btn py-1"
									style={ { backgroundColor: "#0465AC", color: "white" } }
									onClick={ () => {
										clearGetAssignee();
										setShowModalAddAssinees(true);

									} }
								>
									<Add /> Add Assignee
								</button>
							</div>
						</div>
					</div>
					<div className='col-12 py-2' style={ { backgroundColor: '#f6f7fc', } }>

						<div className=' my-2 d-flex align-items-center  flex-wrap' style={ { gap: '10px' } } >
							<div className="normalBoldFont px-2 d-flex justify-content-center align-items-center">Filter By</div>
							<div className=''>
								<select
									onChange={ (e) => {
										onChangeAssigneeUserType(e);
									} }
									className="w-100 secondaryColor selectBox"
									value = { getAssignee.userType }
								>
									<option value={ '' }>Select User Type</option>
									<option value={ 'student' }>Student</option>
									<option value={ 'teaching' }>Teaching</option>
									<option value={ 'nonteaching' }>Non Teaching</option>
								</select>
							</div>
							{ getAssignee.userType && getAssignee.userType === 'student' && <div className=''>
								<select
									onChange={ (e) => {
										onChangeAssigneeYear(e);
									} }
									value={ getAssignee.academicIdArray }
									className="smallFont w-100 secondaryColor selectBox"
								>
									<option value=''>Select Academic Year</option>
									{ dataFetchingGetAcademicYearListObject ?
										<Spinner /> :
										academicYearSortedArr.map(academicYearId => {

											return <option value={ academicYearId }>{ getAcademicYearListObject[academicYearId].year_text }</option>
										})
									}
								</select>

							</div> }
							{ getAssignee.userType && (getAssignee.userType === 'student' || getAssignee.userType === 'teaching' || getAssignee.userType === 'nonteaching') && <div div className=''>
								<select
									onChange={ (e) => {
										onChangeAssigneeDepartment(e);
									} }
									value={ getAssignee.departmentId }
									className="smallFont w-100 secondaryColor selectBox"
								>
									<option value=''>Select Department</option>
									{ dataFetchingGetInstituteStreamsObject ?
										<Spinner /> :

										Object.keys(instituteStreamsObject).map(departmentId => {
											return <option value={ departmentId }>{ instituteStreamsObject[departmentId].stream_name }</option>
										})
									}
								</select>
							</div> }

							{ getAssignee.userType && getAssignee.userType === 'student' && <div className=''>
								<select
									onChange={ (e) => {
										onChangeAssigneeGroup(e);
									} }
									value={ getAssignee.groupId }
									className="smallFont w-100 secondaryColor selectBox"
								>
									<option value=''>Select Groups</option>
									{ dataFetchingGetGroupList ?
										<Spinner /> :
										Object.keys(getGroupList).map(groupId => {

											return <option value={ groupId }>{ getGroupList[groupId].groupName }</option>
										})
									}
								</select>
							</div> }

							<div style={ { display: "flex", justifyContent: "space-between", alignItems: 'center' } }>
								<button
									style={ { color: '#0465AC' } }
									onClick={ () => viewNoticeAssigneeList() }
									className='btn'>View</button>
								<button
								    className="btn btn-primary"
									style={ { fontWeight: 'bold', fontSize: 14, marginLeft: 10, cursor: 'pointer' } }
									onClick={ () => clearNoticeAssigneeList() }
								>Clear</button>


							</div>
						</div>
					</div>
					<div className='col-12 my-3'>

						{/* table for assigness */ }
						<div className='scrollController tableBodyAssignee'>
							{
								(dataFetchingNoticeAssigneeList
									?
									<Spinner />
									:
									(noticeAssigneeList && (
										<div className='table-responsive' >
											<table className="table table-sm table-bordered">
												<thead >
													<tr>
														<th style={ { padding: 5 } }>
															<div>
																<input
																	checked={ tempNoticeAssigneeArrayForDelete.length !== 0 && tempNoticeAssigneeArrayForDelete.length === Object.keys(noticeAssigneeList).length ? true : false }
																	onChange={ () => selectAllAssigneesForDelete() }
																	type="checkbox" value="" />
															</div>
														</th>
														<th style={ { padding: 5 } } className='smallFont'>Sr. No.</th>
														<th style={ { padding: 5 } } className='smallFont'>First Name</th>
														<th style={ { padding: 5 } } className='smallFont'>Last Name</th>
														<th style={ { padding: 5 } } className='smallFont'>Department</th>
														<th style={ { padding: 5 } } className='smallFont'>Group</th>
														<th style={ { padding: 5 } } className='smallFont'>Role</th>
													</tr>
												</thead>
												<tbody>
													{ tempNoticeAssigneeArrayForDelete.length >= 1 &&
														<tr>
															<th colSpan="7" className='actionButtonsBelt'>
																<span onClick={
																	() => { setShowModalConfirmation(true); }
																} className='actionButtonsBelt_Button' >
																	Remove
																</span>
															</th>
														</tr> }
													{
														noticeAssigneeList.length !== 0 ?
															Object.values(noticeAssigneeList).map((notice, noticeIndex) => {
																return <tr>
																	<td style={ { padding: 5 } } >
																		<div >
																			<input
																				checked={ tempNoticeAssigneeArrayForDelete.includes(notice.uniqueId) ? true : false }
																				onChange={ () => selectOneAssigneesForDelete(notice.uniqueId) }
																				type="checkbox" value="" />
																		</div>
																	</td>
																	<td style={ { padding: 5 } }>{ pagination.offset + noticeIndex + 1 }</td>
																	<td style={ { padding: 5 } }>{ notice.userFirstName }</td>
																	<td style={ { padding: 5 } }>{ notice.userLastName }</td>
																	<td style={ { padding: 5 } }>{ notice.streamName }</td>
																	<td style={ { padding: 5 } }>{ notice.groupName }</td>
																	<td style={ { padding: 5 } } className='capitalizeWord'>{  notice.userRole === "nonteaching" ? "Non-Teaching" : notice.userRole }</td>
																</tr>
															})
															: <tr >
																<td colSpan="8" className="secondaryColor pl-2">
																	No assignee added yet. Please click on "Add Assignee" to assign the notice.
																</td>
															</tr>
													}
												</tbody>
											</table>
										</div>
									)))
							}
						</div>

						{/* component for pagination */ }
						{
							dataFetchingNoticeAssigneeList == false && Object.keys(noticeAssigneeList).length > 0 &&
							<div className="paginationContainer">
								<Pagination
									activePage={ pagination.pageIndex }
									itemsCountPerPage={ pagination.limit }
									totalItemsCount={ totalCount }
									pageRangeDisplayed={ 3 }
									onChange={ (num) => updatePaginationCount(num) }
								/>
							</div>
						}

					</div>
				</div>
			</div>

		</div>


		{/* modal for assignee */ }
		{
			showModalAddAssinees && <div>
				<div className="modal fade show" id="modalContainer"  >
					<div className="modal-dialog modal-dialog-centered modal-xl h-75" >
						<div className="h-100 modal-content">

							<div className="modal-header d-flex text-center p-2" style={ { backgroundColor: '#0465ac' } } >
								<div className=" flex-grow-1">
									<h5 className="modal-title text-white">Add Assignees</h5>
								</div>
								<div className="">
									<Close style={ { color: 'white', cursor: 'pointer' } }
										onClick={ () => {
											setShowModalAddAssinees(false);
											clearData();
											getNoticeAssigneeList()
										} } />
								</div>
							</div>

							<div className="" style={ { overflow: 'auto' } }>
								{/* { JSON.stringify(getAssignee) } */ }

								<div className='col-12  my-3 d-flex align-items-center flex-wrap' style={ { backgroundColor: '#f6f7fc', } }>
									<div className=' my-2 d-flex align-items-start flex-wrap' style={ { gap: '15px' } }>
										<div className=''>
											<select
												onChange={ (e) => {
													clearGetAssignee();
													setIsClickOnSearch(false)
													setAssignee(prev => ({ ...prev, userType: e.target.value }));
												} }
												className="smallFont w-100 secondaryColor selectBox"
											>
												<option value={ '' }>Select User Type</option>
												<option value={ 'student' }>Student</option>
												<option value={ 'teaching' }>Teaching</option>
												<option value={ 'nonteaching' }>Non Teaching</option>
											</select>
											{ getAssignee.userType === '' && showImpWarning('user type') }
										</div>
										{ getAssignee.userType && getAssignee.userType === 'student' && <div className=''>
											<select
												onChange={ (e) => {
													setAssignee(prev => ({ ...prev, academicYearId: e.target.value }));
												} }
												value={ getAssignee.academicYearId }
												className="smallFont w-100 secondaryColor selectBox"
											>
												<option value={ getAssignee.academicIdArray }>Select Academic Year</option>
												{ dataFetchingGetAcademicYearListObject ?
													<Spinner /> :
													academicYearSortedArr.map(academicYearId => {

														return <option value={ academicYearId }>{ getAcademicYearListObject[academicYearId].year_text }</option>
													})
												}
											</select>
											{ getAssignee.userType === 'student' && getAssignee.academicYearId === '' && showImpWarning('academic year') }

										</div> }
										{ getAssignee.userType && (getAssignee.userType === 'student' || getAssignee.userType === 'teaching' || getAssignee.userType === 'nonteaching') && <div className=''>
											<select
												onChange={ (e) => {
													setAssignee(prev => ({ ...prev, departmentId: e.target.value }));
													setInstDept("")

												} }
												disabled ={instDept != ""}
												value={ getAssignee.departmentId }
												className="smallFont w-100 secondaryColor selectBox"
											>
												<option value=''>Select Department</option>
												{ dataFetchingGetInstituteStreamsObject ?
													<Spinner /> :

													Object.keys(instituteStreamsObject).map(departmentId => {
														return <option value={ departmentId }>{ instituteStreamsObject[departmentId].stream_name }</option>
													})
												}
											</select>
											{ getAssignee.userType === 'student' && getAssignee.departmentId === '' && showImpWarning('department') }

											{/* { (getAssignee.userType === 'teaching' || getAssignee.userType === 'nonteaching') && getAssignee.departmentId === '' && showImpWarning('department') } */}
										</div> }

										{ getAssignee.userType && getAssignee.userType === 'student' && <div className=''>
											<select
												onChange={ (e) => {
													setAssignee(prev => ({ ...prev, groupId: e.target.value }));
												} }
												value={ getAssignee.groupId }
												className="smallFont w-100 secondaryColor selectBox"
											>
												<option value=''>Select Groups</option>
												{ dataFetchingGetGroupList ?
													<Spinner /> :
													(Object.keys(getGroupList).length >= 1 ? Object.keys(getGroupList).map(groupId => {
														return <option value={ groupId }>{ getGroupList[groupId].groupName }</option>
													})
														:
														<option>No data found</option>
													)
												}
											</select>

										</div> }
										{ (getAssignee.userType === 'teaching' || getAssignee.userType === 'nonteaching') && <div className=''>
											<select
												onChange={ (e) => {
													setInstDept(e.target.value)
													setAssignee(prev => ({ ...prev, departmentId: "" }));
												} }
												disabled = {getAssignee?.departmentId != ""}
												value={instDept}
												className="smallFont w-100 secondaryColor selectBox"
											>
												<option value=''>Select Institute Department</option>
												{ 
													(Object.keys(instituteDepartment).length > 0 ? Object.values(instituteDepartment).map(instDept => {
														return <option value={ instDept?.Id }>{ instDept?.name }</option>
													})
														:
														<option>No data found</option>
													)
												}
											</select>

										</div> }
										<div className=''>
											<div
												onClick={ () => searchAssignee() }
												style={ { backgroundColor: '#0465AC', color: 'white' } }
												className='outlinedButton1'>
												   Search
											</div>
										</div>
									</div>
								</div>

								<div className='col-12 scrollController mt-3 assigneeModalTableDiv'>



									{/* table for faculty */ }
									{ !showInstructions && !isStudentTable &&
										(dataFetchingGetFacultyList
											?
											<Spinner />
											:
											(getFacultyList &&

												(
													<div className='table-responsive'>
														<table className="table table-sm table-bordered">
															<thead >
																<tr>
																	<th style={ { padding: 5 } }>
																		<div>
																			<input
																				checked={ tempNoticeAssigneeArray.length === Object.keys(getFacultyList).length ? true : false }
																				onChange={ (e) => selectAllAssignees(e) }
																				type="checkbox" value="" />
																		</div>
																	</th>
																	<th className='smallFont customTable'>Sr. No.</th>
																	<th className='smallFont customTable'>First Name</th>
																	<th className='smallFont customTable'>Last Name</th>
																	<th className='smallFont customTable'>ERP ID</th>
																	<th className='smallFont customTable'>Email</th>
																	<th className='smallFont customTable'>Contact</th>
																	<th className='smallFont '>Designation</th>
																	<th className='smallFont customTable'>Role</th>
																</tr>
															</thead>
															<tbody>
																{
																	getFacultyList.length !== 0
																		? Object.values(getFacultyList).map((faculty, facultyIndex) => {
																			return <tr>
																				<td style={ { padding: 5 } } >
																					<div >
																						<input
																							checked={ tempNoticeAssigneeArray.includes(faculty.faculty_id) ? true : false }
																							onChange={ () => selectOneAssignees(faculty.faculty_id,) }
																							type="checkbox" value="" />
																					</div>
																				</td>
																				<td style={ { padding: 5 } }>{ facultyIndex + 1 }</td>	
																				<td style={ { padding: 5 } }>{ faculty.faculty_fname }</td>
																				<td style={ { padding: 5 } }>{ faculty.faculty_lname }</td>
																				<td style={ { padding: 5 } }>{ faculty.faculty_user_id }</td>
																				<td style={ { padding: 5 } }>{ faculty.faculty_email }</td>
																				<td style={ { padding: 5 } }>{ faculty.faculty_contact_no }</td>
																				<td style={ { padding: 5 } } className='text-wrap' title={ faculty.designation }>{ faculty.designation }</td>
																				<td style={ { padding: 5 } } className='capitalizeWord'>{ faculty.userrole }</td>
																			</tr>

																		})
																		:
																		<tr >
																			<td colSpan="8" className="secondaryColor">
																				No faculty details found.
																			</td>
																		</tr>
																}
															</tbody>
														</table>
													</div>
												)

											))
									}

									{/* table for student */ }
									{ !showInstructions && isStudentTable && (dataFetchinGetStudentAssignedToGroup
										?
										<Spinner />
										:
										(getStudentAssignedToGroup && (
											<div className='table-responsive'>
												<table className="table table-sm table-bordered">
													<thead >
														<tr>
															<th style={ { padding: 5 } }>
																<div>
																	<input
																		checked={ tempNoticeAssigneeArray.length !== 0 && tempNoticeAssigneeArray.length === Object.keys(getStudentAssignedToGroup).length ? true : false }
																		onChange={ (e) => selectAllAssignees(e) }
																		type="checkbox" value="" />
																</div>
															</th>
															<th style={ { padding: 5 } } className='smallFont'>Sr. No.</th>
															<th style={ { padding: 5 } } className='smallFont'>Roll Number</th>
															<th style={ { padding: 5 } } className='smallFont'>ERP ID</th>
															<th style={ { padding: 5 } } className='smallFont'>First Name</th>
															<th style={ { padding: 5 } } className='smallFont'>Last Name</th>
															<th style={ { padding: 5 } } className='smallFont'>Department</th>
															<th style={ { padding: 5 } } className='smallFont'>Group</th>
															<th style={ { padding: 5 } } className='smallFont'>Role</th>
														</tr>
													</thead>
													<tbody>
														{
															Object.keys(getStudentAssignedToGroup).length !== 0 ?
																studentSequence.map((studentAssignedId, studentAssignedIndex) => {
																	let studentAssigned = getStudentAssignedToGroup[studentAssignedId];
																	return(
																		<tr>
																			<td style={ { padding: 5 } } >
																				<div >
																					<input
																						checked={ tempNoticeAssigneeArray.includes(studentAssigned.studentId) ? true : false }
																						onChange={ () => selectOneAssignees(studentAssigned.studentId) }
																						type="checkbox" 
																					/>
																				</div>
																			</td>
																			<td style={{ padding: 5 }}>{studentAssignedIndex + 1}</td>
																			<td style={{ padding: 5 }}>{studentAssigned.RollNo}</td>
																			<td style={{ padding: 5 }}>{studentAssigned.student_user_id}</td>
																			<td style={{ padding: 5 }}>{studentAssigned.student_first_name}</td>
																			<td style={{ padding: 5 }}>{studentAssigned.student_last_name}</td>
																			<td style={{ padding: 5 }}>{studentAssigned.defaultStreamName}</td>
																			<td style={{ padding: 5 }}>{studentAssigned.defaultGroupName}</td>
																			<td style={{ padding: 5 }} className='capitalizeWord'>Student</td>
																		</tr>
																	);
																})
															: <tr >
																	<td colSpan="8" className="secondaryColor">
																		No student details found.
																	</td>
																</tr>
														}
													</tbody>
												</table>
											</div>
										)))
									}
								</div>


								<div className='col-12 my-2'>
									<div className="d-flex justify-content-end align-items-center">
										<div>
											<div onClick={ () => {
												setShowModalAddAssinees(false);
												clearData();
											} }
												style={ { color: '#0465AC' } }
												className='outlinedButton1'>Cancel</div>
										</div>

										<div>
											<div
												onClick={ () => {
													postAddNoticeAssignee();
													setShowModalAddAssinees(false);
													clearData();
												} }
												style={ { backgroundColor: '#0465AC', color: 'white' } }
												className='outlinedButton1'>Add Assignees</div>
										</div>

									</div>

								</div>
							</div>

						</div>
					</div>
				</div>
			</div>
		}

		{/* confirmation modal */ }
		{
			showModalConfirmation && <ConfirmationModal
				title='remove Assignee' subtitle='Are you sure you want to remove selected assignee ?'
				isFetchingProcessOn={ dataFetchingRemoveAssignee } removeMethod={ postRemoveNoticeAssignee } setShowModalConfirmation={ setShowModalConfirmation } />
		}
		{/* successmodal */ }
		{
			successModalDetails.successModal &&
			<SuccessModal
				successModal={ successModalDetails.successModal }
				successModalType={ successModalDetails.successModalType }
				successMessage={ successModalDetails.successMessage }
				closeSuccessModal={ closeSuccessModal }
			/>
		}
		
	</>;
}

export default Assignees;
